import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';

const rootEl = document.getElementById('root');

// react-snap pre-renders HTML — use hydrateRoot on pre-rendered pages
if (rootEl.hasChildNodes()) {
  hydrateRoot(rootEl, <React.StrictMode><App /></React.StrictMode>);
} else {
  createRoot(rootEl).render(<React.StrictMode><App /></React.StrictMode>);
}
